import { type FC, StrictMode } from "react";
import { RouterProvider } from "react-router";

import { Toaster } from "sonner";

import { ApolloProvider } from "@apollo/client/react";

import { client } from "@application/config/apollo";

import { useStorage } from "@application/hooks/use_storage";

import { router } from "./router";
import { World } from "@application/contexts/world";

export const App: FC = () => {
  const [authenticated, setAuthenticated] = useStorage(
    localStorage ?? sessionStorage,
    "authenticated",
  );

  const login = (): void => {
    setAuthenticated("1");
  };

  const logout = (): void => {
    setAuthenticated(undefined);
  };

  return (
    <StrictMode>
      <Toaster />
      <World.Provider value={{ login, logout, authenticated: !!authenticated }}>
        <ApolloProvider client={client}>
          <RouterProvider router={router} />
        </ApolloProvider>
      </World.Provider>
    </StrictMode>
  );
};
